import React from 'react';
import './ValuationReport.css';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import Sidebar from '../../components/Sidebar/Sidebar';

// Finansal tablo için örnek veri
const financialData = [
    { year: '2025', sales: '476.943', grossProfit: '176.177', ebitda: '-1.836.067' },
    { year: '2026', sales: '1.641.896', grossProfit: '14.239.458', ebitda: '10.877.583' },
    { year: '2027', sales: '3.358.129', grossProfit: '37.472.773', ebitda: '4.688.410' },
    { year: '2028', sales: '5.485.151', grossProfit: '92.423.879', ebitda: '48.963.459' },
];

const ValuationReport = () => {
    const reportData = {
        companyName: 'SeedXpert',
        companyTitle: 'SeedXpert Değerleme ve Danışmanlık A.Ş.',
        logoUrl: 'https://via.placeholder.com/150x60.png?text=Şirket+Logosu',
        berkus: {
            team: { score: 'Güçlü', text: 'Kurucu ekip, çeşitli uzmanlık alanlarına (teknoloji, satış, finans) sahip olup, sektörde ortalama 5+ yıl deneyime sahiptir. Bu durum, şirketin stratejik ve operasyonel zorluklara karşı dayanıklılığını artırmaktadır.' },
            market: { score: 'Yüksek', text: 'Girişim, Yapay Zeka ve FinTech gibi yüksek büyüme potansiyeline sahip bir pazarda faaliyet göstermektedir. Pazar büyüklüğü uluslararası nitelikte olup, henüz yerleşik ve yıkıcı bir rakip bulunmamaktadır.' },
            product: { score: 'İleri', text: 'Şirket, çalışan bir MVP\'ye (Minimum Uygulanabilir Ürün) sahiptir ve ürünün teknolojisi, rakipler tarafından kolayca kopyalanamayacak niteliktedir. Satış döngüsünün 1-3 ay gibi kısa bir sürede olması, nakit akışı potansiyelini artırmaktadır.' },
            businessModel: { score: 'Ölçeklenebilir', text: 'İş modeli, artan müşteri sayısına karşılık maliyetlerin aynı oranda artmadığı, yüksek kâr marjı potansiyeli sunan ölçeklenebilir bir yapıdadır.' },
            ip: { score: 'Orta', text: 'Şirket, fikri mülkiyet hakları için başvuru aşamasındadır. Bu süreç tamamlandığında rekabet avantajı daha da güçlenecektir.' },
            totalQualitativeScore: '78 / 100'
        },
        financials: {
            revenueGrowth: 'Yıllık ortalama %150 büyüme projeksiyonu.',
            profitability: 'Brüt kâr marjı %85 seviyesinde olup, net kârın 2. yıldan itibaren pozitif olması beklenmektedir.',
            cashFlow: 'Negatif. İlk yatırım turu sonrası 18 aylık nakit akışı güvence altına alınmıştır.',
            financialRisks: 'Genel Giderler: 250.000 USD, Satış/Pazarlama: 450.000 USD, Personel: 800.000 USD, Ar-Ge: 300.000 USD.'
        },
        strengths: [
            'Deneyimli ve birbirini tamamlayan kurucu ekip.',
            'Yüksek büyüme potansiyeline sahip niş bir pazarda faaliyet göstermesi.',
            'Kopyalanması zor, benzersiz teknoloji altyapısı.'
        ],
        risks: [
            'Satışların hedeflenenin altında kalması durumunda nakit akışının negatife dönme riski.',
            'Faaliyet gösterilen alanda olası bir regülasyon belirsizliği.',
            'Agresif büyüme stratejisinin operasyonel zorluklar yaratma potansiyeli.'
        ],
        valuation: {
            berkusValue: '$2.1 milyon USD',
            dcfValue: '$1.8 milyon - $2.5 milyon USD',
            finalValue: '$2.0 milyon USD'
        },
        recommendations: [
            'İş modelini farklı coğrafyalara ölçeklendirme stratejileri geliştirilmeli.',
            'Nakit akışını daha verimli yönetmek için finansal kontrol mekanizmaları güçlendirilmeli.',
            'Fikri mülkiyet koruması için patent süreçleri hızlandırılmalıdır.'
        ]
    };

    return (
        <div className="page-layout">
            <Sidebar />
            <div className="content-area">
                <ProgressBar />
                <div className="report-container">
                    
                    {/* --- Header --- */}
                    <div className="report-header">
                        <img src={reportData.logoUrl} alt="Şirket Logosu" className="company-logo" />
                        <div className="company-info">
                            <h1>Şirket Değerleme Raporu</h1>
                            <p className="company-name">{reportData.companyName}</p>
                            <p className="company-title">{reportData.companyTitle}</p>
                        </div>
                        <button className="download-pdf-button">PDF İndir</button>
                    </div>

                    {/* --- 1. Genel Bakış --- */}
                    <div className="report-section">
                        <h2>1. Genel Bakış</h2>
                        <p>Bu rapor, <strong>{reportData.companyName}</strong> şirketinin Berkus yöntemiyle ve İndirgenmiş Nakit Akışı (DCF) yapılan niteliksel değerlendirmesi ile finansal performansının entegrasyonunu içermektedir.</p>
                        <p>Berkus Yöntemi ile yapılan analiz sonucu şirketiniz kapsamında yapılan analiz sonucu aşağıdaki gibidir.</p>
                    </div>

                    {/* --- 2. Niteliksel Değerlendirme --- */}
                    <div className="report-section">
                        <h2>2. Niteliksel Değerlendirme (Berkus Yöntemi Sonuçları)</h2>
                        <div className="qualitative-grid">
                            <div className="qualitative-item">
                                <h3>Takım ve Yönetim: <span className="score-strong">{reportData.berkus.team.score}</span></h3>
                                <p>{reportData.berkus.team.text}</p>
                            </div>
                            <div className="qualitative-item">
                                <h3>Pazar Potansiyeli: <span className="score-high">{reportData.berkus.market.score}</span></h3>
                                <p>{reportData.berkus.market.text}</p>
                            </div>
                            <div className="qualitative-item">
                                <h3>Ürün ve Teknoloji: <span className="score-advanced">{reportData.berkus.product.score}</span></h3>
                                <p>{reportData.berkus.product.text}</p>
                            </div>
                            <div className="qualitative-item">
                                <h3>İş Modeli: <span className="score-strong">{reportData.berkus.businessModel.score}</span></h3>
                                <p>{reportData.berkus.businessModel.text}</p>
                            </div>
                            <div className="qualitative-item">
                                <h3>Fikri Mülkiyet ve Sosyal: <span className="score-medium">{reportData.berkus.ip.score}</span></h3>
                                <p>{reportData.berkus.ip.text}</p>
                            </div>
                        </div>
                        <p className="total-qualitative-score">
                            Analiz sonucu Niteliksel puan toplamı: <strong>{reportData.berkus.totalQualitativeScore}</strong>
                        </p>
                    </div>

                    {/* --- 3. Finansal Performans --- */}
                    <div className="report-section">
                        <h2>3. Finansal Performans ve Projeksiyonlar</h2>
                        <div className="financial-summary">
                            <p><strong>Gelir ve Büyüme:</strong> {reportData.financials.revenueGrowth}</p>
                            <p><strong>Kârlılık:</strong> {reportData.financials.profitability}</p>
                            <p><strong>Nakit Akışı:</strong> {reportData.financials.cashFlow}</p>
                            <p><strong>Finansal Riskler:</strong> {reportData.financials.financialRisks}</p>
                        </div>
                        <h3 className="table-title">Gelir-Gider ve EBITDA Tablosu</h3>
                        <div className="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Kalem</th>
                                        {financialData.map(data => <th key={data.year}>{data.year}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Toplam Satışlar</td>
                                        {financialData.map(data => <td key={data.year}>${data.sales}</td>)}
                                    </tr>
                                    <tr className="profit-row">
                                        <td>Brüt Kâr</td>
                                        {financialData.map(data => <td key={data.year}>${data.grossProfit}</td>)}
                                    </tr>
                                    <tr className="profit-row">
                                        <td>EBITDA</td>
                                        {financialData.map(data => <td key={data.year}>${data.ebitda}</td>)}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* --- 4. Güçlü Yönler ve Riskler --- */}
                    <div className="report-section strengths-risks">
                        <div className="strengths">
                            <h3>Güçlü Yönler</h3>
                            <ul>
                                {reportData.strengths.map((item, index) => <li key={index}>{item}</li>)}
                            </ul>
                        </div>
                        <div className="risks">
                            <h3>Riskler</h3>
                            <ul>
                                {reportData.risks.map((item, index) => <li key={index}>{item}</li>)}
                            </ul>
                        </div>
                    </div>

                    {/* --- 5. Değerleme Sonucu --- */}
                    <div className="report-section valuation-result">
                        <h2>5. Değerleme Sonucu</h2>
                        <div className="valuation-grid">
                            <div className="valuation-item">
                                <h4>Berkus Yöntemiyle Tahmini Değer</h4>
                                <p>{reportData.valuation.berkusValue}</p>
                            </div>
                            <div className="valuation-item">
                                <h4>İndirgenmiş Nakit Akışı (DCF)</h4>
                                <p>{reportData.valuation.dcfValue}</p>
                            </div>
                        </div>
                        <div className="final-valuation">
                            <h3>Sonuç</h3>
                            <p>Şirketin güncel piyasa değeri yaklaşık olarak <strong>{reportData.valuation.finalValue}</strong> seviyesinde tahmin edilmektedir.</p>
                        </div>
                    </div>

                    {/* --- 6. Öneriler --- */}
                    <div className="report-section">
                        <h2>6. Öneriler ve İleri Adımlar</h2>
                        <ul>
                            {reportData.recommendations.map((item, index) => <li key={index}>{item}</li>)}
                        </ul>
                        <div className="report-notes">
                            <p><strong>Not:</strong> Bu rapordaki projeksiyonlar {reportData.companyName} tarafından sağlanan verilere dayalıdır.</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ValuationReport;
